import { QueryClientProvider } from '@tanstack/react-query'

import { getQueryClient } from './get-client'

export function ReactQueryProvider({ children }: React.PropsWithChildren) {
    const queryClient = getQueryClient()

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
